export default {"src":"/_next/static/media/calendarFour_24.9331d75a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};